import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {message} from 'antd';
import UnionComponent from 'Components/union/unionComponent';
import tDetailActions from 'Actions/taskManage/detail';
// import {getWeekDays} from 'Utils';
import moment from 'moment';

import Header from './header';
import Search from './search';
import TableList from './tableList';
import ReloadModal from '../../systemSetting/exportTasks/modal/reloadModal';
import ReCallModal from './components/reCallModal';

import './index.less';

class Detail extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      downloadData: props.searchData,
      tableListLoading: false,
      reloadModalVisible: false, // 重新创建弹框是否可见
      reCallModalVisible: false, // 一键重呼弹窗
      pageType: 'detail',
    };
    this.TableComponent = null;
  }

  componentWillUnmount() {
    const {actions} = this.props;
    actions.setSearchData({
      commitTimeStart: moment(
        `${moment().format('YYYY-MM-DD')} 00:00:00`,
      ).format('x'),
      commitTimeEnd: moment(`${moment().format('YYYY-MM-DD')} 23:59:59`).format(
        'x',
      ),
      orderKey: 'commit_time',
    });
    actions.setPageStatus({pageNum: 1, pageSize: 20});
  }

  // 设置下载参数
  setDownloadData = downloadData => {
    this.setState({
      downloadData,
    });
  };

  // 设置重新创建导出弹框显示隐藏
  setReloadModalVisible = () => {
    const {reloadModalVisible} = this.state;
    this.setState({
      reloadModalVisible: !reloadModalVisible,
    });
  };

  // 设置重新外呼弹框显示隐藏
  setReCallModalVisible = () => {
    const {reCallModalVisible} = this.state;
    this.setState({
      reCallModalVisible: !reCallModalVisible,
    });
  };

  exportTask = taskName => {
    const {actions} = this.props;
    const {downloadData} = this.state;

    const user = window.localStorage.getItem('user');
    const vccId = JSON.parse(user).profile?.vcc_id;
    const deptId = JSON.parse(user).profile?.dept_id;
    const userId = JSON.parse(user).profile?.user_id;
    const urlParmas = {
      ...downloadData,
      vccId,
      deptId,
      userId,
      syncTaskName: taskName,
    };
    actions.exportTask(urlParmas).then(res => {
      if (res.payload.code === 200) {
        message.success('创建导出任务成功！');
      }
    });
  };
  onRef= childComponent => {
    this.TableComponent = childComponent
  }

  render() {
    const {
      pageType,
      downloadData,
      reloadModalVisible,
      reCallModalVisible,
      tableListLoading,
    } = this.state;
    return (
      <div className="taskManageDetail">
        <Header
          downloadData={downloadData}
          setReloadModalVisible={this.setReloadModalVisible}
          setReCallModalVisible={this.setReCallModalVisible}
        />

        <Search
          getTableList={this.getCustomizeTableList}
          setDownloadData={this.setDownloadData}
          getTableComponent={() => this.TableComponent}
        />

        <TableList
          onRef={this.onRef}
          loading={tableListLoading}
          setTableListLoading={this.setTableListLoading}
          getTableList={this.getCustomizeTableList}
        />

        {reloadModalVisible ? (
          <ReloadModal
            setReloadModalVisible={this.setReloadModalVisible}
            exportTask={this.exportTask}
            pageType={pageType}
          />
        ) : null}

        {reCallModalVisible ? (
          <ReCallModal
            getTableList={this.getCustomizeTableList}
            setReCallModalVisible={this.setReCallModalVisible}
            exportTask={this.exportTask}
            pageType={pageType}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({taskManageDetail}) => ({
  searchData: taskManageDetail.searchData,
  downloadData: taskManageDetail.downloadData,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tDetailActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Detail);
